<template>
  <div>
    <router-link v-if="!value.children && value.router && !value.hidden" :to="value.router">
      <el-menu-item :index="value.router">
        <div>
          <i class="iconfont" v-if="value.icon" :class="`icon-${value.icon}`"></i>
          <span>{{(value.title || '暂无名称')}}</span>
        </div>
      </el-menu-item>
    </router-link>

    <el-submenu v-if="value.children && value.children.length > 0 && !value.hidden" :index="value.id + ''">
      <fragment slot="title">
        <div>
          <i class="iconfont"  v-if="value.icon" :class="`icon-${value.icon}`"></i>
          <span>{{(value.title || '暂无名称')}}</span>
        </div>
      </fragment>
      <fragment v-for="(item, index) in value.children" :key="index">
        <menu-item :value="item"></menu-item>
      </fragment>
    </el-submenu>
  </div>
</template>

<script>
import menuItem from '@/components/layout/menuItem'
export default {
  name: 'menuItem',
  components: {
    menuItem: menuItem
  },
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped lang="less">
.iconfont{
  font-size: 22px;
  font-weight: bold;
  margin-right: 20px;
}
</style>
